import axios from "axios";

export const getAll = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/certificates`);
};

export const create = payload => {
  return axios.post(`${process.env.VUE_APP_API_URL}/certificates`, payload);
};

export const update = (id, payload) => {
  return axios.post(
    `${process.env.VUE_APP_API_URL}/certificates/${id}?_method=PUT`,
    payload
  );
};

export const remove = id => {
  return axios.delete(`${process.env.VUE_APP_API_URL}/certificates/${id}`);
};

export const getOptions = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/certificates/options`);
};

export const preview = (payload) => {
  return axios.post(`${process.env.VUE_APP_API_URL}/certificates/preview`, payload);
}
